/**
 * @generated SignedSource<<ded45af53ef2158eecb1da85c83f24d1>>
 * @relayHash 0ca724c5b283169613eccca7c170cbed
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/569.0.0-2026-07-21T15:16:16.695Z/SellerReviewsModalQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerReviewsModalQuery$variables = {
  isMobileScrollContainer: boolean;
  orderByHighest: boolean;
  orderByLowest: boolean;
  orderByNewest: boolean;
  page: number;
  sellerId: string;
};
export type SellerReviewsModalQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SellerReviewsMobileModalContent_viewer" | "SellerReviewsModalContent_viewer">;
  };
};
export type SellerReviewsModalQuery = {
  response: SellerReviewsModalQuery$data;
  variables: SellerReviewsModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMobileScrollContainer"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderByHighest"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderByLowest"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderByNewest"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sellerId"
},
v6 = {
  "alias": "feedbackFormPhotoUpload",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "feedbackFormPhotoUpload"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"feedbackFormPhotoUpload\")"
},
v7 = {
  "kind": "Literal",
  "name": "excludeInAppealProcess",
  "value": true
},
v8 = {
  "kind": "Literal",
  "name": "excludePrivateItemReviews",
  "value": true
},
v9 = {
  "kind": "Variable",
  "name": "sellerId",
  "variableName": "sellerId"
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderFeedbackMultipleQueryMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatedOrderFeedbackType",
      "kind": "LinkedField",
      "name": "aggregatedFeedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackQuestionType",
          "kind": "LinkedField",
          "name": "overallExperience",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mean",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfPages",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contemporaryTrackingString",
      "storageKey": null
    },
    (v13/*:: as any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "thumb"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"thumb\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v12/*:: as any*/),
        (v13/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLinkable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "publicNote",
  "plural": false,
  "selections": [
    (v15/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        }
      ],
      "type": "StandardQuestion",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "freetext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visible",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedDate",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerFirstName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "OrderFeedbackPhoto",
  "kind": "LinkedField",
  "name": "orderPhotos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    (v13/*:: as any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "buyerShippingAddress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayCountry",
      "storageKey": null
    },
    (v13/*:: as any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "overallExperience",
  "plural": false,
  "selections": [
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rating",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v23 = {
  "kind": "Literal",
  "name": "orderByNewest",
  "value": true
},
v24 = {
  "alias": "reviewsWithPhotos",
  "args": [
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    {
      "kind": "Literal",
      "name": "first",
      "value": 0
    },
    {
      "kind": "Literal",
      "name": "hasVisibleFeedbackImages",
      "value": true
    },
    (v23/*:: as any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": 0
    },
    (v9/*:: as any*/)
  ],
  "concreteType": "OrderFeedbackMultipleQueryConnection",
  "kind": "LinkedField",
  "name": "orderFeedbackMultiple",
  "plural": false,
  "selections": [
    (v22/*:: as any*/)
  ],
  "storageKey": null
},
v25 = [
  (v7/*:: as any*/),
  (v8/*:: as any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "orderByHighest",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "orderByLowest",
    "value": false
  },
  (v23/*:: as any*/),
  (v9/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SellerReviewsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SellerReviewsModalContent_viewer"
              }
            ]
          },
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SellerReviewsMobileModalContent_viewer"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*:: as any*/),
      (v0/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "SellerReviewsModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": [
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 3
                  },
                  {
                    "kind": "Variable",
                    "name": "orderByHighest",
                    "variableName": "orderByHighest"
                  },
                  {
                    "kind": "Variable",
                    "name": "orderByLowest",
                    "variableName": "orderByLowest"
                  },
                  {
                    "kind": "Variable",
                    "name": "orderByNewest",
                    "variableName": "orderByNewest"
                  },
                  {
                    "kind": "Variable",
                    "name": "page",
                    "variableName": "page"
                  },
                  (v9/*:: as any*/)
                ],
                "concreteType": "OrderFeedbackMultipleQueryConnection",
                "kind": "LinkedField",
                "name": "orderFeedbackMultiple",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderFeedbackMultipleQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderFeedback",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v14/*:: as any*/),
                          (v16/*:: as any*/),
                          (v17/*:: as any*/),
                          (v18/*:: as any*/),
                          (v19/*:: as any*/),
                          (v20/*:: as any*/),
                          (v21/*:: as any*/),
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*:: as any*/)
                ],
                "storageKey": null
              },
              (v24/*:: as any*/)
            ]
          },
          {
            "condition": "isMobileScrollContainer",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v6/*:: as any*/),
              {
                "alias": "paginatedFeedback",
                "args": (v25/*:: as any*/),
                "concreteType": "OrderFeedbackMultipleQueryConnection",
                "kind": "LinkedField",
                "name": "orderFeedbackMultiple",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderFeedbackMultipleQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrderFeedback",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*:: as any*/),
                          (v14/*:: as any*/),
                          (v16/*:: as any*/),
                          (v17/*:: as any*/),
                          (v18/*:: as any*/),
                          (v19/*:: as any*/),
                          (v20/*:: as any*/),
                          (v21/*:: as any*/),
                          (v13/*:: as any*/),
                          (v15/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "paginatedFeedback",
                "args": (v25/*:: as any*/),
                "filters": [
                  "sellerId",
                  "excludeInAppealProcess",
                  "orderByNewest",
                  "orderByHighest",
                  "orderByLowest",
                  "excludePrivateItemReviews"
                ],
                "handle": "connection",
                "key": "SellerReviewsMobileModalContent_paginatedFeedback",
                "kind": "LinkedHandle",
                "name": "orderFeedbackMultiple"
              },
              (v24/*:: as any*/)
            ]
          },
          (v13/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/569.0.0-2026-07-21T15:16:16.695Z/SellerReviewsModalQuery",
    "metadata": {},
    "name": "SellerReviewsModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "30191515264875351a8b376be4ebba28";

export default node;
